import * as $ from 'jquery';

const clickHandler = function () {
    const $this = $(this);
    const target = $($this.attr('data-toggle-control-visible'));

    target.each(function () {
        $(this).toggle(0);
    });
};
$('[data-toggle-control-visible]').on('click', clickHandler);
